import * as angular from 'angular';
//Components
import autocomplete from './autocomplete';
import { SubheaderMenuComponent } from './subheaderMenu/subheaderMenu.component';
import { MaterialButtonComponent } from './materialButton/materialButton.component';
import { NotificationsCenterComponent } from './notificationsCenter/notificationsCenter.component';
import { NotificationTextPlainComponent } from './notificationsCenter/notificationCards/notificationTextPlain.component';
import { NotificationWeblinkComponent } from './notificationsCenter/notificationCards/notificationWeblink.component';
import { FragmentLoaderComponent } from './fragmentLoader/fragmentLoader.component';
import { MonacoEditorComponent } from './monacoEditor/monacoEditor.component';
import { MaterialInput } from './materialInput/materialInput.component';
//Services
import { FullScreenService } from './FullScreenService';
import { LoadingService } from './LoadingService';
import { WindowService } from './WindowService';
//Directives
import { ErrorMessagesDirective } from './errorMessages/ErrorMessagesDirective';
export { default as ConfirmationModal } from './confirmationModal';
export { default as StepperModal } from './stepperModal';
export { default as ChecklistModal } from './checklistModal';
//
export default angular
    .module('ui', [])
    .service('FullScreenService', FullScreenService)
    .service('LoadingService', LoadingService)
    .service('WindowService', WindowService)
    .component('autocomplete', autocomplete)
    .component('subheaderMenu', SubheaderMenuComponent)
    .component('materialButton', MaterialButtonComponent)
    .component('notificationsCenter', NotificationsCenterComponent)
    .component('notificationTextplain', NotificationTextPlainComponent)
    .component('notificationWeblink', NotificationWeblinkComponent)
    .component('fragmentLoader', FragmentLoaderComponent)
    .component('monacoEditor', MonacoEditorComponent)
    .component('materialInput', MaterialInput)
    .directive('errorMessages', ErrorMessagesDirective.factory)
    .run(['FullScreenService', function (FullScreenService) {
        FullScreenService.addFullScreenDefaultListener();
    }]).name;
